import appGlobalScript from '/builds/project/congstar-congo/library/javascript/content-loader/src/globals.js';
export const globalScripts = appGlobalScript;
